/* eslint-disable no-param-reassign */
import { last } from 'lodash';
import {
  ORCHESTRATION_SERVICE_API, VIEWPOINT_API, ACCOUNT_MANAGEMENT_API,
} from 'constants/AppConstants';
import {
  AUTHORIZE_ROUTE,
} from 'constants/RouteConstants';
import { getAuthToken } from './utils/auth.utils';
import { isOpenSitemapPath } from './utils/sitemapOpenPage.utils';

const INTERCEPTOR_IGNORE_FILE_EXT = ['json', 'img'];

const isPublicSitemapUrl = (url) => typeof url === 'string' && url.includes('/v1/sitemap/');

/**
 * Intercepts an API call and appends the access token in the request header
 */
const Interceptor = async () => {
  const fetchIntercept = await import('fetch-intercept');
  const register = () => fetchIntercept.register({
    request(url, config) {
      if (
        (typeof url === 'string')
        && (!INTERCEPTOR_IGNORE_FILE_EXT.includes(last(url.split('.'))))
        && (
          url.includes(ORCHESTRATION_SERVICE_API)
          || url.includes(VIEWPOINT_API)
          || url.includes(ACCOUNT_MANAGEMENT_API)
        )
      ) {
        if (typeof config !== 'object' || config === null) {
          config = {};
        }
        let { headers } = config;
        const { skipAuthHeader } = config;
        if (!(headers instanceof Headers)) {
          headers = new Headers(headers);
          config.headers = headers;
        }

        // Public sitemap open-page APIs must never send a Bearer token —
        // Istio rejects invalid/expired JWTs before the handler runs.
        if (isPublicSitemapUrl(url) || skipAuthHeader) {
          headers.delete('Authorization');
        } else if (!headers.has('Authorization')) {
          headers.append('Authorization', `Bearer ${getAuthToken()}`);
        }
      }
      return [url, config];
    },

    requestError(error) {
      return Promise.reject(error);
    },

    response(response) {
      const { status } = response;
      // Open pages (e.g. sitemap approval email link) must stay usable when logged out
      // or when a stale token causes an unrelated 401 (entitlements, etc.).
      // window.location includes the /myev basename; history paths do not.
      const onOpenSitemapPage = isOpenSitemapPath(globalThis.location?.pathname);
      if (
        status === 401
        && !onOpenSitemapPage
        && !(response.url && isPublicSitemapUrl(response.url))
      ) {
        globalThis.location.href = AUTHORIZE_ROUTE;
      }
      return response;
    },

    responseError(error) {
      return Promise.reject(error);
    },
  });
  return {
    register,
    fetchIntercept,
  };
};

export default Interceptor;
